export default {
    configuration: false,
    searchList: {
        searchTxt: [
            {
                name: '服务平台',
                value: 'siteName',
                unfold: true,
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' }
                ],
                method: 'post',
                prefix: '/api-tms/',
                advanceUrl: '/user/auth/data/site/query',
                type: 'advance',
                cbParams: [
                    'escoCompanyNo#siteCode',
                    'escoCompanyNameCn#siteName'
                ],
                span: 4
            },
            {
                name: '仓库',
                value: 'whName',
                unfold: true,
                advanceConfig: [
                    { prop: 'cdwhName', value: '仓库名称' },
                    { prop: 'whCode', value: '仓库编码' }
                ],
                tableConfig: [
                    { prop: 'whCode', value: '仓库编码' },
                    { prop: 'cdwhName', value: '仓库名称' }
                ],
                advanceUrl: 'cdWarehouse/search?cdwhIsStop=0',
                type: 'advance',
                cbParams: [
                    'whCode', 'cdwhName#whName'
                ],
                span: 5
            },
            {
                name: '创建时间',
                value: 'createTime',
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间',
                type: 'time',
                unfold: true,
                timeNum: 30,
                span: 5
            },
            {
                name: '状态',
                value: 'activeFlag',
                type: 'select',
                options: [
                    { label: '启用', value: '1' },
                    { label: '停用', value: '0' }
                ],
                unfold: true,
                span: 3
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        tableCut: false,
        clickModify: true,
        selectBtn: true,
        height: '400px',
        columns: [
            {
                label: '服务平台',
                prop: 'siteName',
                width: 160,
                sort: true
            },
            {
                label: '仓库',
                prop: 'whName',
                width: 160
            },
            {
                label: '装货预约配置',
                prop: 'loadList',
                width: 160
            },
            {
                label: '备注',
                prop: 'remark',
                width: 160
            },
            {
                label: '状态',
                prop: 'activeFlag',
                width: 80,
                type: 'select',
                optionNum: '',
                options: [
                    { value: '0', label: '停用' },
                    { value: '1', label: '启用' }
                ]
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: 100,
                sort: true
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: 160,
                sort: true
            },
            {
                label: '修改人',
                prop: 'updateUserName',
                width: 100,
                sort: true
            },
            {
                label: '修改时间',
                prop: 'updateTime',
                width: 160,
                sort: true
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    }
};
